<template>
  <div class="footer">
    <div class="footer-box ">
      <ul class="mobile_hide"  >
        <li v-if="footData.footNewMessages" class="box-01">
          <h5>{{$t("home_3")}} <span class="line"></span></h5>
          <div class="dotted-box dotted-147"  v-for="(item,index) in footData.footNewMessages.footNewMessagesListDto"  :key="index">
            <router-link  :to="'/newsDetails/'+item.id">
                <div class="dotted-line">
                  <span>{{item.date}}</span>
                 <a href="#">{{item.typeName}}</a>
                </div>
                 <div class="">
                   <p>{{item.title}}</p>
                 </div>
            </router-link>
          </div>
          <div>
            <router-link  to="/news" class="more">{{$t("home_29")}}</router-link>
          </div>
        </li>
        <li v-if="footData.kind" class="box-02">
          <h5>{{footData.kind.name}}<span class="line"></span></h5>
          <ol>
            <li v-for="(item,index) in footData.kind.kindList" :key="index"><router-link :to="item.path + '/' + item.id">{{item.name}}</router-link></li>
          </ol>
        </li>
        <li class="box-03">
          <h5>{{$t("home_41")}}<span class="line"></span></h5>
          <ol class="left-ol w-50">
            <li><a href="https://www.bafangdumpling.com/" target="_blank">{{$t("home_58")}}</a></li>
            <li><a href="https://www.fjveggie.com.tw/" target="_blank">{{$t("home_57")}}</a></li>
            <li><a href="https://www.buygood.com.tw" target="_blank">{{$t("home_56")}}</a></li>
            <li><a href="https://www.facebook.com/8wayTW" target="_blank">{{$t("home_43")}}</a></li>
            <li><a href="https://msn.sgs.com/VIP_zone.aspx?cstno=NjZVQ3NZMStGQ21OTExJeDlza0NaUT09" target="_blank">{{$t("home_45")}}</a></li>
            <li><router-link :to="'/setAim'" target="_blank">{{$t("home_01")}}</router-link></li>
           <!-- <li><a href="/investor" target="_blank">{{$t("home_46")}}</a></li>-->
          </ol>
          <!-- 右邊結構,超過5個請打開顯示 -->
          <!-- <ol class="right-ol w-50">
            <li><a href="https://www.buygood.com.tw" target="_blank">{{$t("home_56")}}</a></li>
          </ol> -->
        </li>
        <li class="box-04">
          <a href="/home"><div class="footImg"></div></a>
          <div class="solid-line">
            <p>{{$t("home_47")}}</p>
            <p>0800-898-000</p>
          </div>
          <div class="solid-line">
            <p>{{$t("home_48")}}</p>
            <p>{{$t("home_49")}}</p>
          </div>
            <div class="solid-line">
            <p><a href="/contactUs" >{{$t("home_4")}}</a></p>
          </div>
        </li>
      </ul>

      <div class="footer-ownership">
        <p>Copyright 2024 © 八方雲集國際股份有限公司 All Rights Reserved </p>
      </div>
    </div>
  </div>


</template>

<script>
import API from '../config/api'
export default {
  name: 'Footer',
  inject:['reload'],
  data () {
    return {
      footData:{}
    }

  },
  created() {
   this.GetFootList();
  },
  mounted(){

  },
  methods:{
    GetFootList:function(){
      this.$fetch(API.GetWebFootList).then((response) => {
          if(response.code == 200){
          this.footData = response.data;
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 .footer{
   width: 100%;
   height: auto;
   position: relative;
   margin-top: -130px;
 }
.footer-box{
  width:100%;
  height:auto;
  background: url(../../assets/images/footerTopBg.svg) no-repeat center top;
  text-align:center;
  background-size: 100%;
  padding:0 110px;
  .left-ol{
    float:left;
    padding-right: 5px;
  }
  .right-ol{
    float:right;
    padding-left: 5px;
  }
  ul{
    padding-left:0;
    margin-bottom: 48px;
    overflow: hidden;
    padding-top: 240px;
    li{
    /*  width: 25%;*/
      float: left;
      text-align: left;
      h5{
        color: #2A1C15;
        font-size: 26px;
        letter-spacing: 1.22px;
        padding-bottom: 20px;
        font-weight: 500;
      }
      .line{
        height: 5px;
        width: 25px;
        background-color: #F5AC2D;
        margin-top: 15px;
        display: block;
      }
      ol{
        padding-left:0;
        li{
         width:38%;
          padding-bottom: 20px;

          &:nth-child(2n-1){
            clear: both;
          }
           a{
            font-size: 17px;
            color: #000;
            letter-spacing: 1.27px;
            line-height: 17px;
            &:hover{
               color: #CE0A00;
               font-weight: 500;
             }
            }
        }
      }
      .w-50{
        li{
          width: 100%;
        }
      }
     .dotted-box{
       .dotted-line{
        border-bottom: 1px dashed #979797;
        padding-bottom:16px;
         span{
           color: #000000;
           font-size: 18px;
           font-family: "Roboto Medium Italic";
           line-height: 21px;
           letter-spacing: 0.9px;
         }
        a{
          height: 26px;
          line-height: 26px;
          width: 104px;
          background-color: #D00717;
          color: #fff;
          float: right;
          text-align: center;
          font-size: 14px;
          letter-spacing: 0.88px;
        }
      }
       p{
         font-size: 17px;
         margin-bottom: 35px;
         padding-top: 12px;
         line-height: 25px;
         letter-spacing: 1.42px;
         color: #000;
       }
       &.dotted-147{
         padding-right: 147px;
        }

     }
    .footImg{
      /*width: 83%;*/
      height: 199px;
      width: 353px;
      padding-bottom: 49%;
      background: url('../../assets/images/footerLogo.svg') no-repeat center center;
      background-size: 100%;
      margin-top:-100px;
    }
    .solid-line{
      width: 97%;
      border-bottom: 0.5px solid #DDDDDD;
      margin-bottom: 22px;
      padding-top: 11px;
      font-size: 17px;
      line-height: 27px;
      p{
        padding-bottom: 12px;
        padding-left: 10px;
        &:nth-child(1){
           letter-spacing: 1.5px;
           font-weight: 500;
           line-height: 15px;
         }
        &:nth-child(2){
          letter-spacing: 1.27px;
         }
      }
     }
     .more{
       color: #F5AC2D;
       font-size: 20px;
       font-weight: 500;
       line-height: 32px;
       background: url(../../assets/images/moreYellow.png) no-repeat -2px bottom;
       padding-bottom:20px;
       padding-right: 8px;
       letter-spacing: 1.42px;
       display: block;
     }

    }
    .box-01{
      width: 481px;
    }
    .box-02{
      width: 363px;
      ol{
        li{
          padding-right:10px; /*原30px最後一個字在螢幕寬度不足時會折行*/
        }
      }
    }
    .box-03{
      width:470px;
    }
   .box-04{
     width:353px;
   }
  }
}
.footer-ownership{
  width: 100%;
  height: 70px;
  line-height: 70px;
  border-top: 1px solid #979797;
  p{
    padding-top: 21px;
    text-align: right;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.5px;
    color: #585858;
  }
}
 @media (max-width:1868px){
   .footer-box{
     padding: 0 5%;
   }
   .footer-box ul .box-01{
     width: 35% ;
   }
   .footer-box ul .box-02,
   .footer-box ul .box-03{
     width: 20% ;
   }
   .footer-box ul .box-04
   {
     width: 25% ;
   }
   .footer-box ul li .footImg{
     width: 84%;
     height: auto;
   }
 }
 @media (max-width:1314px){
   .footer-box ul .box-01{
     width: 30% ;
   }
   .footer-box ul .box-02{
     width: 30% ;
   }
   .footer-box ul .box-03{
     width:20% ;
   }
   .footer-box ul .box-04
   {
     width: 20% ;
   }
   .footer-box ul li .dotted-box.dotted-147{
     padding-right:60px;
   }

 }
 @media (max-width:1080px){
   .footer{
     margin-top: -54px;
   }

   .all-lr5{
     padding: 0;
   }

   .footer-box{
      padding-bottom: 113px;
    }

   .footer-ownership{
     padding: 0 14px;
     padding-top: 90px;
     border-top: 0;
   }

   .footer-ownership p{
     text-align: left;
     font-size: 11px;
     border-top: 1px solid #979797;
     line-height: 2;
     padding-top: 10px;
   }
 }

  @media (max-width:767px){
    .footer-box{
      background-image: url("../../assets/images/footerTopBg-mobile.png");
      background-size: 100% auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/default/Footer.vue